<ng-container *ngIf="save$ | async"></ng-container>
<ng-container *ngIf="action$ | async"></ng-container>

<mat-tab-group class="h-full">
  <mat-tab *ngIf="hasSlots(thisSlotTypeEnum.InPlate)">
    <ng-template mat-tab-label>
      <div class="slot-img-wrapper">
        <img i18n-alt src="assets/images/grooves/in-plate.svg" alt="Паз в пласти" />
      </div>
    </ng-template>

    <table class="simple">
      <thead>
        <tr>
          <th></th>
          <th i18n>Название</th>
          <th i18n>Обозначение</th>
          <th><ng-container i18n>Ширина</ng-container> (H)</th>
          <th><ng-container i18n>Глубина</ng-container> (G)</th>
          <th><ng-container i18n>Смещение</ng-container> (dx)</th>
          <th class="delete-col"></th>
          <th *ngIf="isShowWarnColumn()" class="warn-col"></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of slots">
          <tr *ngIf="item.type === thisSlotTypeEnum.InPlate">
            <td>
              <mat-checkbox
                data-testid="slotsCheckBox"
                (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(item) : null"
                [checked]="selection.isSelected(item)"
                [disabled]="compareDepthSlotWithFullPanelThickness(item)">
              </mat-checkbox>
            </td>
            <td data-testid="slotName">{{ item.name }}</td>
            <td>{{ item.designation }}</td>
            <td>{{ item.h | number : '1.0-2' }}</td>
            <td>{{ item.g | number : '1.0-2' }}</td>
            <td>{{ item.dx | number : '1.0-2' }}</td>
            <td class="delete-col">
              <button mat-icon-button (click)="deleteSlot(item)" *ngIf="item.custom">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
            <td *ngIf="isShowWarnColumn()" class="warn-col">
              <mat-icon
                *ngIf="compareDepthSlotWithFullPanelThickness(item)"
                i18n-matTooltip
                class="mat-warn"
                matTooltip="Паз недоступен для выбора. Глубина паза больше толщины панели. Толщина панели равна {{
                  fullPanelThickness
                }} мм"
                >warning</mat-icon
              >
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>

    <div class="m-8 flex flex-col items-center" *ngIf="hasCustomSlots(thisSlotTypeEnum.InPlate)">
      <button
        [disabled]="disabledAddYourSlotButton(thisSlotTypeEnum.InPlate)"
        i18n
        mat-flat-button
        color="accent"
        (click)="openCustomSlotDetailDialog(thisSlotTypeEnum.InPlate)"
        >Добавить свой паз</button
      >
    </div>
  </mat-tab>

  <mat-tab *ngIf="hasSlots(thisSlotTypeEnum.InSide)">
    <ng-template mat-tab-label>
      <div class="slot-img-wrapper">
        <img src="assets/images/grooves/in-side.svg" alt="Паз в торце" />
      </div>
    </ng-template>

    <table class="simple">
      <thead>
        <tr>
          <th></th>
          <th i18n>Название</th>
          <th i18n>Обозначение</th>
          <th><ng-container i18n>Ширина</ng-container> (H)</th>
          <th><ng-container i18n>Глубина</ng-container> (G)</th>
          <td><ng-container i18n>Смещение</ng-container> (dx)</td>
          <th class="delete-col"></th>
          <th class="warn-col"></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of slots">
          <tr *ngIf="item.type === thisSlotTypeEnum.InSide">
            <td>
              <mat-checkbox
                data-testid="slotsCheckBox"
                (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(item) : null"
                [checked]="selection.isSelected(item)"
                [disabled]="compareDepthSlotWithFullPanelThickness(item)">
              </mat-checkbox>
            </td>
            <td data-testid="slotName">{{ item.name }}</td>
            <td>{{ item.designation }}</td>
            <td>{{ item.h | number : '1.0-2' }}</td>
            <td>{{ item.g | number : '1.0-2' }}</td>
            <td>{{ item.dx | number : '1.0-2' }}</td>
            <td class="delete-col">
              <button mat-icon-button (click)="deleteSlot(item)" *ngIf="item.custom">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
            <td class="warn-col">
              <mat-icon
                *ngIf="compareDepthSlotWithFullPanelThickness(item)"
                i18n-matTooltip
                class="mat-warn"
                matTooltip="Паз недоступен для выбора. Глубина паза больше толщины панели. Толщина панели равна {{
                  fullPanelThickness
                }} мм"
                >warning</mat-icon
              >
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>

    <div class="m-8 flex flex-col items-center" *ngIf="hasCustomSlots(thisSlotTypeEnum.InSide)">
      <button
        [disabled]="disabledAddYourSlotButton(thisSlotTypeEnum.InSide)"
        i18n
        mat-flat-button
        color="accent"
        (click)="openCustomSlotDetailDialog(thisSlotTypeEnum.InSide)"
        >Добавить свой паз</button
      >
    </div>
  </mat-tab>

  <mat-tab *ngIf="hasSlots(thisSlotTypeEnum.Rabbet)">
    <ng-template mat-tab-label>
      <div class="slot-img-wrapper">
        <img src="assets/images/grooves/rabbet.svg" alt="Четверть" />
      </div>
    </ng-template>

    <table class="simple">
      <thead>
        <tr>
          <th></th>
          <th i18n>Название</th>
          <th i18n>Обозначение</th>
          <th><ng-container i18n>Ширина</ng-container> (H)</th>
          <th><ng-container i18n>Глубина</ng-container> (G)</th>
          <th class="delete-col"></th>
          <th class="warn-col"></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of slots">
          <tr *ngIf="item.type === thisSlotTypeEnum.Rabbet">
            <td>
              <mat-checkbox
                data-testid="slotsCheckBox"
                (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(item) : null"
                [checked]="selection.isSelected(item)"
                [disabled]="compareDepthSlotWithFullPanelThickness(item)">
              </mat-checkbox>
            </td>
            <td data-testid="slotName">{{ item.name }}</td>
            <td>{{ item.designation }}</td>
            <td>{{ item.h | number : '1.0-2' }}</td>
            <td>{{ item.g | number : '1.0-2' }}</td>
            <td class="delete-col">
              <button mat-icon-button (click)="deleteSlot(item)" *ngIf="item.custom">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
            <td class="warn-col">
              <mat-icon
                *ngIf="compareDepthSlotWithFullPanelThickness(item)"
                i18n-matTooltip
                class="mat-warn"
                matTooltip="Паз недоступен для выбора. Глубина паза больше толщины панели. Толщина панели равна {{
                  fullPanelThickness
                }} мм"
                >warning</mat-icon
              >
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>

    <div class="m-8 flex flex-col items-center" *ngIf="hasCustomSlots(thisSlotTypeEnum.Rabbet)">
      <button
        [disabled]="disabledAddYourSlotButton(thisSlotTypeEnum.Rabbet)"
        i18n
        mat-flat-button
        color="accent"
        (click)="openCustomSlotDetailDialog(thisSlotTypeEnum.Rabbet)"
        >Добавить свой паз</button
      >
    </div>
  </mat-tab>

  <mat-tab *ngIf="hasSlots(thisSlotTypeEnum.Chamfer)">
    <ng-template mat-tab-label>
      <div class="slot-img-wrapper">
        <img src="assets/images/grooves/chamfer.svg" alt="Срез" />
      </div>
    </ng-template>

    <table class="simple">
      <thead>
        <tr>
          <th></th>
          <th i18n>Название</th>
          <th i18n>Обозначение</th>
          <th i18n>Угол (Fi)</th>
          <th class="delete-col"></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of slots">
          <tr *ngIf="item.type === thisSlotTypeEnum.Chamfer">
            <td>
              <mat-checkbox
                data-testid="slotsCheckBox"
                (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(item) : null"
                [checked]="selection.isSelected(item)">
              </mat-checkbox>
            </td>
            <td data-testid="slotName">{{ item.name }}</td>
            <td>{{ item.designation }}</td>
            <td>{{ item.fi | number : '1.0-2' }}</td>
            <td class="delete-col">
              <button mat-icon-button (click)="deleteSlot(item)" *ngIf="item.custom">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>

    <div class="m-8 flex flex-col items-center" *ngIf="hasCustomSlots(thisSlotTypeEnum.Chamfer)">
      <button
        [disabled]="disabledAddYourSlotButton(thisSlotTypeEnum.Chamfer)"
        i18n
        mat-flat-button
        color="accent"
        (click)="openCustomSlotDetailDialog(thisSlotTypeEnum.Chamfer)"
        >Добавить свой паз</button
      >
    </div>
  </mat-tab>

  <mat-tab *ngIf="hasSlots(thisSlotTypeEnum.Chamfer2)">
    <ng-template mat-tab-label>
      <div class="slot-img-wrapper">
        <img src="assets/images/grooves/chamfer2.svg" alt="Фаска" />
      </div>
    </ng-template>

    <table class="simple">
      <thead>
        <tr>
          <th></th>
          <th i18n>Название</th>
          <th i18n>Обозначение</th>
          <th i18n>Смещение (B)</th>
          <th i18n>Смещение (dx)</th>
          <th class="delete-col"></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of slots">
          <tr *ngIf="item.type === thisSlotTypeEnum.Chamfer2">
            <td>
              <mat-checkbox
                data-testid="slotsCheckBox"
                (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(item) : null"
                [checked]="selection.isSelected(item)">
              </mat-checkbox>
            </td>
            <td data-testid="slotName">{{ item.name }}</td>
            <td>{{ item.designation }}</td>
            <td>{{ item.b | number : '1.0-2' }}</td>
            <td>{{ item.dx | number : '1.0-2' }}</td>
            <td class="delete-col">
              <button mat-icon-button (click)="deleteSlot(item)" *ngIf="item.custom">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>

    <div class="m-8 flex flex-col items-center" *ngIf="hasCustomSlots(thisSlotTypeEnum.Chamfer2)">
      <button
        [disabled]="disabledAddYourSlotButton(thisSlotTypeEnum.Chamfer2)"
        i18n
        mat-flat-button
        color="accent"
        (click)="openCustomSlotDetailDialog(thisSlotTypeEnum.Chamfer2)"
        >Добавить свой паз</button
      >
    </div>
  </mat-tab>

  <mat-tab *ngIf="hasSlots(thisSlotTypeEnum.Fillet)">
    <ng-template mat-tab-label>
      <div class="slot-img-wrapper">
        <img src="assets/images/grooves/fillet.svg" alt="Фаска" />
      </div>
    </ng-template>

    <table class="simple">
      <thead>
        <tr>
          <th></th>
          <th i18n>Название</th>
          <th i18n>Обозначение</th>
          <th i18n>Радиус (R)</th>
          <th class="delete-col"></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of slots">
          <tr *ngIf="item.type === thisSlotTypeEnum.Fillet">
            <td>
              <mat-checkbox
                data-testid="slotsCheckBox"
                (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(item) : null"
                [checked]="selection.isSelected(item)">
              </mat-checkbox>
            </td>
            <td data-testid="slotName">{{ item.name }}</td>
            <td>{{ item.designation }}</td>
            <td>{{ item.r | number : '1.0-2' }}</td>
            <td class="delete-col">
              <button mat-icon-button (click)="deleteSlot(item)" *ngIf="item.custom">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>

    <div class="m-8 flex flex-col items-center" *ngIf="hasCustomSlots(thisSlotTypeEnum.Fillet)">
      <button
        [disabled]="disabledAddYourSlotButton(thisSlotTypeEnum.Fillet)"
        i18n
        mat-flat-button
        color="accent"
        (click)="openCustomSlotDetailDialog(thisSlotTypeEnum.Fillet)"
        >Добавить свой паз</button
      >
    </div>
  </mat-tab>
</mat-tab-group>
